import React from "react";
import { MdPeople, MdPersonAdd, MdFavorite } from "react-icons/md";
import Card from "components/card";
import StatCard from "components/stat-card";
import { formatNumber } from "utils/format";
import CardError from "./CardError";

const KPIS = [
  { key: "attendance", label: "Attendance", icon: MdPeople, accent: "sky" },
  { key: "firstTimeGuests", label: "First-Time Guests", icon: MdPersonAdd, accent: "sage" },
  { key: "salvations", label: "Salvations", icon: MdFavorite, accent: "slate" },
];

const KPICards = ({ data, loading, error, onRetry }) => {
  if (error) {
    return (
      <Card padding="md">
        <CardError title="Couldn't Load Key Metrics" error={error} onRetry={onRetry} />
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
      {KPIS.map(({ key, label, icon, accent }) => {
        const trend = data?.[key]?.trend;
        return (
          <StatCard
            key={key}
            size="lg"
            icon={icon}
            accent={accent}
            label={label}
            value={formatNumber(data?.[key]?.value)}
            trend={trend == null ? undefined : { value: trend }}
            caption="Last 30 days"
            loading={loading}
            href="/admin/attendance/reports"
          />
        );
      })}
    </div>
  );
};

export default KPICards;
